import { IT } from "../language";

export const configMocked = {
  defaultLanguage: IT,
};
